import { movies } from "@/mocks/movies";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import HotRanking from "@/pages/home/components/HotRanking";
import CategoryQuickLinks from "@/pages/home/components/CategoryQuickLinks";
import MovieSection from "@/pages/home/components/MovieSection";

export default function Home() {
  const heroItems = movies.filter((m) => m.banner).slice(0, 5);
  const ranking = [...movies].sort((a, b) => b.heat - a.heat).slice(0, 5);
  const latest = [...movies]
    .sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1))
    .slice(0, 8);
  const hot = [...movies].sort((a, b) => b.heat - a.heat).slice(0, 8);
  const topRated = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 8);

  return (
    <div className="mx-auto w-full max-w-[1280px] px-4 py-8 md:px-6 md:py-10">
      <h1 className="sr-only">国产在线观看 - 高清国产电影电视剧综艺在线观看平台</h1>

      <div className="grid gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <HeroCarousel items={heroItems} />
        </div>
        <div className="lg:col-span-1">
          <HotRanking items={ranking} />
        </div>
      </div>

      <div className="mt-10">
        <CategoryQuickLinks />
      </div>

      <div className="mt-12">
        <MovieSection
          title="最新更新"
          subtitle="按更新时间倒序，热门资源第一时间上线"
          icon="ri-time-line"
          movies={latest}
          moreLink="/category/电影"
        />
      </div>

      <div className="mt-12">
        <MovieSection
          title="热门推荐"
          subtitle="根据播放热度精选，大家都在看"
          icon="ri-fire-line"
          movies={hot}
          moreLink="/category/电视剧"
        />
      </div>

      <div className="mt-12">
        <MovieSection
          title="口碑高分"
          subtitle="豆瓣高分国产影视作品精选"
          icon="ri-award-line"
          movies={topRated}
          moreLink="/category/综艺"
        />
      </div>
    </div>
  );
}